export default __webpack_public_path__ + "static/media/Sliders-Home-03-1.e2a85cf9.webp";